// extracted by mini-css-extract-plugin
module.exports = {"panel":"panel--3ANiRyHp","page":"page--2l85vDmj"};